import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined) return '0';

    let num = Number(value);
    if (isNaN(num)) return String(value);

    if (num < 1000) {
      return num.toString();
    }

    if (num < 1_000_000) {
      return (num / 1000).toFixed(num >= 10_000 ? 0 : 1) + 'K';
    }

    if (num < 1_000_000_000) {
      return (num / 1_000_000).toFixed(num >= 10_000_000 ? 0 : 1) + 'M';
    }

    return (num / 1_000_000_000).toFixed(num >= 10_000_000_000 ? 0 : 1) + 'B';
  }
}
